module.exports = __webpack_public_path__ + "media/assets/submit_arrow-6ec3abd8cc6e66116ede16f8ad4f5796.svg";